var formSubmitted = false;

function getSelectedSwatches() {
  var selectedSwatchNames = [], selectedSwatchElements = [];
  $('.swatchList li.selected').each(function() {
    var swatch = $(this);
    selectedSwatchNames.push(swatch.attr("data-swatch-name"));
    selectedSwatchElements.push(swatch);
  });
  $("#contactForm").find('textarea[name="requested-swatches-9"]').text(selectedSwatchNames.join(",\n"));
  $("#contactForm").find('textarea[name="product-name-10"]').text(productName);
}

const formConfig = {attributes: true, childList: true, subtree: true};

const callback = (mutationList, formObserver) => {
  for (const mutation of mutationList) {
    if (mutation.target.className == "eapps-form-form") {
      $(".modalContainer[data-content='request-swatch'] #currentProductInfo").remove();
      $(".modalContainer[data-content='request-swatch'] #swatches").remove();
      $(".modalContainer[data-content='request-swatch'] #contactForm").remove();
      $(".modalContainer[data-content='request-swatch'] #swatchMessage").addClass("visible");
      formSubmitted = true;
    }
  }
};

const formObserver = new MutationObserver(callback);
formObserver.disconnect();

$(document).ready(function() {
  $(".swatchList li").click(function() {
    const targetNode = document.getElementById("contactForm");
    formObserver.observe(targetNode, formConfig);
  })

  $("#contactForm").find('textarea').text("");
  function hideSwatchForm() {
    $("body").removeClass("scrollingDisabled");
    $('#requestSwatchPopupContainer').removeClass("visible");
    $("#swatches").show();
    $("#contactForm").removeClass("visible");
  }
  $('#popupExit i').click(hideSwatchForm);
  $('#backToProductButton').click(function() {
    $("body").removeClass("scrollingDisabled");
    $(".modalButton[data-content='request-swatch']").remove();
    $(".modalContainer[data-content='request-swatch']").remove();
  });
  
  var selectedSwatchCount = 0, swatchLimit = 3;
  $('.swatchList li').click(function() {
    var swatch = $(this);
    if (swatch.hasClass("selected")) {
      swatch.removeClass("selected");
      selectedSwatchCount --;
    }
    else {
      if (selectedSwatchCount < swatchLimit) {
        swatch.addClass("selected");
        selectedSwatchCount ++;
      }
    }
    $(".chosenCount").text(`${selectedSwatchCount}/${swatchLimit} chosen`);
    getSelectedSwatches();
  });
  
  $('#requestSwatchButton').click(function() {
    if (selectedSwatchCount > 0) {
      $("#swatches").hide();
      $(".bottomBar").hide();
      $("#selectedSwatchInfo").show();
      $("#contactForm").addClass("visible");
      $("#requestSwatchPopup").scrollTop(0);
      getSelectedSwatches();
      setTimeout(() => {
        $("#contactForm").find('textarea[name="product-name-10"]').text(productName);
      }, 2000);
    }
  });
  
  $("#resetSwatches").click(function() {
    $('.swatchList li.selected').each(function() {
      $(this).removeClass("selected");
    });
    $("#contactForm").find('textarea[name="requested-swatches-9"]').text("");
    $(".chosenCount").text(`0/${swatchLimit} chosen`);
    selectedSwatchCount = 0
  })
  
  $('#contactForm .navButton').click(function() {
    $("#swatches").show();
    $(".bottomBar").show();
    $("#contactForm").removeClass("visible");
  });
});